/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { startTransition, useEffect, useLayoutEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { errorState, loadingState, loginState, modalState, modalTypeState, smatroReigistBillingState, userExistsState, userRegistIngState, userRegistState, userSocialRegistState, variableState } from "../../recoil/atoms";
import { CheckBox, Div, Font, Form, Input, Label, PageLayout } from "../../styles/commonStyle";
import { cardTitleColor, cardTitleColor2, fontGreyColor, orangeColor2, primaryColor } from "../../styles/theme";
import evWhereLogo from "../../assets/images/logo_evwhere.png";
import stepActive from "../../assets/images/register-step-active.png";
import stepInactive from "../../assets/images/register-step-inactive.png";
import { Flex, Line, LinkAccountSection, RoundButton } from "../linkAccount/style";
import TermsAgreement from "../linkAccount/components/termsAgreement";
import StepProgress from "./components/stepProgress";
import PhoneVerification from "../linkAccount/components/phoneVerification";
import { FormInput, FormItem, FormLabel, FormButton, FormSelect } from "./style";
import { EvFormPhone, EvFormText } from "./components/formItem";
import { Checkbox } from "../linkAccount/components/style";
import { FieldValues, useForm } from "react-hook-form";
import { POSTCODE_URL } from "../../constants";
import { useDaumPostcodePopup } from "react-daum-postcode";
import { ediDateNoFormat, makeEncryptData, makeMoid, paycardHypen, TodayFormatYYYYMMDDHHmmssSSS, todayNoFoarmat } from "../../util";
import { isMobile } from "react-device-detect";
import { ResponseModel, RESULT } from "../../model/response";
import usePost from "../../hooks/usePost";
import { userExistsSelector, userRegistSelector } from "../../recoil/variableAtom";
import useFetch from "../../hooks/useFetch";
import Loading from "../../components/loading/loading";
import PasswordToggleButton from "../../components/passwordToggleButton/passwordToggleButton";
import { onInputOnlyEng } from "../../validation";

const TOGGLE_ON_BG = 'rgba(255, 129, 22, 0.1)';
const TOGGLE_ON_COLOR = '#ff8116';

function CreateAccountPage() {

    const {
        register: memberRegister,
        handleSubmit: memberHandleSubmit,
        setValue,
        getValues,
        watch,
        setError,
        formState: { errors },
        reset,
    } = useForm({
        mode: "onSubmit",  // 제출 시에만 validation
        reValidateMode: "onSubmit"
    });
    const [getBody, setBody] = useState<any>();
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordCheck, setShowPasswordCheck] = useState(false);
    const [isCheckIdClicked, setIsCheckIdClicked] = useState(false);
    useLayoutEffect(() => {
        reset(); // 모든 필드 초기화
    }, []);
    async function onRegistSubmit(data: FieldValues) {
        var phone = data.phoneFirst + data.phoneSecond + data.phoneThird;
        if(phone.length !== 11) {
            alert('휴대폰 번호를 다시 인증해주세요.');
            return;
        }
        var email;
        var ssbypCode;
        data.emailDomain === 'other' ?
            email = data.emailId + '@' + data.emailDomainInput
            : email = data.emailId + '@' + data.emailDomain;
        if (data.ssbyp == 'google') {
            ssbypCode = '02';
        } else if (data.ssbyp == 'kakao') {
            ssbypCode = '03';
        } else if (data.ssbyp == 'apple') {
            ssbypCode = '04';
        } else {
            ssbypCode = '00';
        }
        let requestData = {
            supplierCode: "TD",
            ty: "MEMBER",
            lgnId: data.lgnId,
            nm: data.nm,
            cardOffer: data.checkMemberCard ? 'Y' : 'N',
            phone: phone,
            email: email,
            lgnPassword: data.lgnPassword,
            adres: data.adres,
            rdnmadr: data.rdnmadr,
            adresDetail: data.adresDetail,
            zipCode: data.zipCode,
            paycardNo: data.paycardNo,
            paycardExp: data.paycardExp,
            paycardBirth: data.paycardBirth,
            paycardPw: data.paycardPw,
            smsRcptnAgreYn: data.sms ? "Y" : "N",
            emlRcptnAgreYn: data.email ? "Y" : "N",
            smartControlPrivacyYn: data.soc ? "Y" : "N",
            ssbyp: ssbypCode,
            socialLoginId: data.socialLoginId,
            socialToken: data.socialToken,
        }
        if (!data.socialToken) {
            delete data.socialLoginId;
            delete data.socialToken;
        }
        if (!data.checkMemberCard) {
            delete requestData.adres;
            delete requestData.rdnmadr;
            delete requestData.adresDetail;
            delete requestData.zipCode;
        }
        setBody(requestData);
    }
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setLoading] = useRecoilState(loadingState);
    const steps = [
        { label: "본인인증", activeImg: stepActive, inactiveImg: stepInactive },
        { label: "약관동의", activeImg: stepActive, inactiveImg: stepInactive },
        { label: "회원정보입력", activeImg: stepActive, inactiveImg: stepInactive },
    ];

    const [step, setStep] = useState(0);
    const [isPhoneVerification, setIsPhoneVerification] = useState(false);
    const [isCert, setIsCert] = useState(false);
    const [termsState, setTermsState] = useState({
        requiredChecked: false,
        optional: { 
            marketing: false, 
            email: false, 
            sms: false, 
            soc: false 
        },
        all: {
            terms: false,
            privacy: false,
            location: false,
            age: false,
            soc: false,
            marketing: false,
            email: false,
            sms: false,
        }
    });
    const [userRegistIng, setUserRegistIng] = useRecoilState(userRegistIngState);
    const [userSocialRegist, setUserSocialRegist] = useRecoilState(userSocialRegistState);
    const [smatroReigistBilling, setSmatroReigistBilling] = useRecoilState(smatroReigistBillingState);
    const [smartroScriptLoading, setSmartroScriptLoading] = useState(false);
    const [Moid, setMoid] = useState("");
    const [EdiDate, setEdiDate] = useState("");
    const [EncryptData, setEncryptData] = useState("");
    const [isPayCard, setIsPayCard] = useState(false);
    const response: ResponseModel<any> = usePost({
        recoilSelector: userRegistSelector,
        data: getBody,
        recoilState: userRegistState,
    });

    const [userExists, setUserExists] = useRecoilState(userExistsState);
    const responseExists: ResponseModel<any> = useFetch({
        recoilSelector: userExistsSelector,
        query: userExists
    });

    useEffect(() => {
        if (userRegistIng) {
            setValue('phoneFirst', userRegistIng.phoneFirst);
            setValue('phoneSecond', userRegistIng.phoneSecond);
            setValue('phoneThird', userRegistIng.phoneThird);
        }
    }, [userRegistIng, setValue]);

    useEffect(() => {
        setSmatroReigistBilling(undefined);
        if (userRegistIng) {
            return () => {
                setUserRegistIng(undefined);
                localStorage.removeItem('recoil-persist-userRegistIngState');
            };
        }
    }, []);

    useEffect(() => {
        if (userSocialRegist) {
            setUserRegistIng({
                authCode: '',
                phoneFirst: '',
                phoneSecond: '',
                phoneThird: '',
                lgnId: '',
                lgnPassword: '',
                nm: '',
                checkMemberCard: false,
                ssbyp: userSocialRegist.ssbyp,
                idToken: userSocialRegist.idToken,
                socialLoginId: userSocialRegist.lgn_Id,
                socialToken: userSocialRegist.idToken,
            });
        }
    }, []);

    const handleCheckCert = () => {
        setIsCert(true);
    }

    const handleCheckExists = () => {
        setIsCheckIdClicked(true);
        if (getValues('lgnId').length < 3 || getValues('lgnId').length > 20 || !/^[a-zA-Z0-9]+$/.test(getValues('lgnId'))) {
            alert('3~20자 영문,숫자만 사용 가능합니다.');
            return;
        }
        setUserExists({
            lgn_id: getValues('lgnId'),
            phone: getValues('phoneFirst') + getValues('phoneSecond') + getValues('phoneThird'),
        });
    };

    useEffect(() => {
        if (!isCheckIdClicked) return;
        
        if (responseExists?.result === RESULT.OK) {
            if (responseExists.data === true) {
                setError('lgnId', {
                    type: 'manual',
                    message: '이미 가입된 아이디입니다.'
                });
            } else {
                // 중복되지 않은 경우 에러 메시지 제거
                setError('lgnId', {
                    type: 'manual',
                    message: ''
                });
                alert('사용 가능한 아이디입니다.');
            }
            setIsCheckIdClicked(false);
        }
    }, [responseExists]);



    useEffect(() => {
        if (response?.result === RESULT.OK) {
            navigate("/register/complete", { replace: true });
            setSmatroReigistBilling(undefined);
        }
        if (response?.result === RESULT.FAIL) {
            alert(response.msg);
        }
    }, [response]);

    // 컴포넌트 마운트 시 URL 파라미터 확인
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const fn = searchParams.get('fn');
        if (fn) {
            setStep(Number(fn));
        }
    }, []);

    useEffect(() => {
        const handlePopState = () => {
            const searchParams = new URLSearchParams(window.location.search);
            const fn = searchParams.get('fn');
            if (fn) {
                setStep(Number(fn));
            }
        };

        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, []);

    useEffect(() => {
        window.history.pushState("", '', `/register?fn=${step}`)
    }, [step]);

    useEffect(() => {
        if (userRegistIng === undefined) return;
        Object.keys(userRegistIng).forEach(key => {
            setValue(key, userRegistIng[key])
        })
    }, [userRegistIng])

    const gotoNext = () => {
        setStep(step + 1);
    }

    const requstPay = () => {
        // @ts-ignore
        window.smartropay.init({
            mode: process.env.REACT_APP_SMARTRO_MODE,
            actionUri: '/ssb/interface.do'
        });

        // @ts-ignore
        window.smartropay.payment({
            FormId: 'paycardForm'
        });
    }

    useEffect(() => {
        const script = document.createElement('script');
        script.src = isMobile
            ? `${process.env.REACT_APP_SMARTRO_MOBILE}${todayNoFoarmat()}`
            : `${process.env.REACT_APP_SMARTRO_WEB}${todayNoFoarmat()}`;
        script.async = false;
        script.addEventListener('load', () => setSmartroScriptLoading(true));
        document.body.appendChild(script);
        setLoading(false)
    }, []);

    useEffect(() => {
        if (!smartroScriptLoading) {
            return;
        } else {
            const moid = makeMoid();
            const ediDate = ediDateNoFormat();
            setMoid(moid);
            setEdiDate(ediDate);
            setEncryptData(makeEncryptData(ediDate, moid));
        }
    }, [smartroScriptLoading]);

    const onClickChangePaycardHandler = () => {
        setUserRegistIng(getValues());
        requstPay();
    }

    useEffect(() => {
        if (smatroReigistBilling === undefined) return;
        const cardNo = paycardHypen(smatroReigistBilling['DisplayCardNo']);
        setValue('hiddenPaycardNo', cardNo)
        if (cardNo) {
            setIsPayCard(true);
        }
    }, [smatroReigistBilling, setValue])

    useEffect(() => {
        if (smatroReigistBilling) {
            setValue('hiddenPaycardNo', '');
        }
        const hiddenPaycardNo = getValues('hiddenPaycardNo');
        if (hiddenPaycardNo) {
            setIsPayCard(true);
        }
    }, [getValues]);

    useEffect(() => {
        if (location.search) {
            var search = location.search.slice(1)
            var queryParams = search.split('&');
            for (var q in queryParams) {
                var l = queryParams[q].split('=')
                var key = l[0]
                var value = l.slice(1).join('=')
                if (key == 'fn') {
                    setStep(Number(value))
                } else if (key == 'result') {
                    var decodeUrl = decodeURI(value)
                    var jsonResult = JSON.parse(decodeUrl)
                    setSmatroReigistBilling(
                        jsonResult
                    )
                }
            }
        }
    }, [location]);

    // 배송지
    const openPostCode = useDaumPostcodePopup(POSTCODE_URL);

    const postCodeHandleClick = () => {
        openPostCode({ onComplete: postCodeHandleComplete });
    };
    const postCodeHandleComplete = (data: any) => {
        setValue!(
            "rdnmadr",
            data.roadAddress
            // { shouldValidate: true }
        );
        setValue!("adres", data.jibunAddress === "" ? data.autoJibunAddress : data.jibunAddress);
        setValue!("zipCode", data.zonecode);
    };

    return (
        <>
            <PageLayout>
                <Font fontSize="1.75rem" fontWeight="500" color={cardTitleColor2} changeFontSize="20px">
                    evPlug 통합 회원가입
                </Font>
                <LinkAccountSection margin="30px 0 100px 0">
                    <StepProgress steps={steps} current={step} />
                    {
                        step === 0 && <>
                            <PhoneVerification
                                isPhoneVerification={isPhoneVerification}
                                setIsPhoneVerification={setIsPhoneVerification}
                                maxWidth="900px"
                                margin="40px auto"
                                hasLine={false}
                                isEdit={true}
                                title={<>evPlug 회원 통합 회원가입을 위해<br />본인인증을 완료해주세요.</>}
                                subText={<div><div style={{ color: "#222222" }}>인증번호가 카카오톡으로 발송됩니다.</div><div style={{ color: "#777777" }}>인증된 휴대폰번호가 통합 회원 정보로 등록됩니다.</div></div>}
                                register={memberRegister}
                                errors={errors}
                                setValue={setValue}
                                getValues={getValues}
                                handleCheckCert={handleCheckCert}
                            />
                            <Flex justifyContent="center" style={{ maxWidth: "336px", margin: "0 auto" }}>
                                <RoundButton onClick={() => {
                                    if (isCert) {
                                        setUserRegistIng(getValues());
                                        gotoNext()
                                    }
                                }} disabled={!isCert} width="100%" fontSize="16px" height="46px" borderRadius="30px">다음 {'>'}</RoundButton>
                            </Flex>
                        </>
                    }
                    {
                        step === 1 && <>
                            <Div style={{ maxWidth: "900px", margin: "40px auto" }}>
                                <Font fontSize="1.5rem" fontWeight="500" color={cardTitleColor2} changeFontSize="18px">
                                    evPlug 회원 통합 회원가입을 위해<br />서비스 이용약관에 동의해주세요.
                                </Font>
                                <Font style={{ marginTop: "10px" }} fontSize="1rem" color={fontGreyColor} changeFontSize="0.75rem">
                                    통합 회원가입 시 evWhere APP도 사용 가능합니다.
                                </Font>
                            </Div>
                            <TermsAgreement
                                register={memberRegister}
                                setValue={setValue}
                                getValues={getValues}
                                onChange={setTermsState}
                                initialValues={termsState.all}
                            />
                            <Flex justifyContent="center" style={{ maxWidth: "336px", margin: "32px auto 0 auto" }}>
                                <RoundButton onClick={() => {
                                    if (termsState.requiredChecked) {
                                        setUserRegistIng(getValues());
                                        gotoNext()
                                    }
                                }} isDisabled={!termsState.requiredChecked} width="100%" fontSize="16px" height="46px" borderRadius="30px">다음 {'>'}</RoundButton>
                            </Flex>
                        </>
                    }
                    {
                        step === 2 && <>
                            <Div style={{ maxWidth: "900px", margin: "40px auto" }}>
                                <Font fontSize="1.5rem" fontWeight="500" color={cardTitleColor2} changeFontSize="18px">
                                    evPlug 회원 통합 회원가입을 위해<br />회원 정보를 입력해주세요.
                                </Font>
                                <Font style={{ marginTop: "10px" }} fontSize="1rem" color={fontGreyColor} changeFontSize="0.75rem">
                                    가입 즉시, 바로 사용 가능한 evPlug 온라인 카드가 발급됩니다.
                                </Font>
                            </Div>
                            <Form onSubmit={memberHandleSubmit(onRegistSubmit)} style={{ maxWidth: "520px", margin: "0 auto" }}>
                                <EvFormText
                                    label="아이디"
                                    name="lgnId"
                                    register={memberRegister}
                                    errors={errors.lgnId}
                                    setValue={setValue}
                                    getValues={getValues}
                                    placeholder="3~20자 영문,숫자 포함"
                                    maxLength={20}
                                    id="lgnId"
                                    required={true}
                                    hasCheckButton={true}
                                    onCheckButtonClick={() => {
                                        handleCheckExists();
                                    }}
                                    validation={{
                                        pattern: {
                                            value: /^[a-zA-Z0-9]{3,20}$/,
                                            message: '3~20자 영문,숫자만 사용 가능합니다.'
                                        }
                                    }}
                                    onInput={onInputOnlyEng}
                                />
                                <div style={{ position: "relative" }}>
                                    <EvFormText
                                        label="비밀번호"
                                        name="lgnPassword"
                                        register={memberRegister}
                                        errors={errors.lgnPassword}
                                        setValue={setValue}
                                        getValues={getValues}
                                        placeholder="8~20자 영문,숫자,특수문자 포함"
                                        maxLength={20}
                                        id="lgnPassword"
                                        required={true}
                                        type={showPassword ? "text" : "password"}
                                        validation={{
                                            pattern: {
                                                value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{3,20}$/,
                                                message: '8~20자 영문, 숫자, 특수문자를 포함하여 입력해주세요.'
                                            }
                                        }}
                                        onInput={onInputOnlyEng}
                                    />
                                    <PasswordToggleButton
                                        showPassword={showPassword}
                                        isEvFormText={true}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setShowPassword(!showPassword);
                                        }}
                                    />
                                </div>
                                <div style={{ position: "relative" }}>
                                    <EvFormText
                                        label="비밀번호 확인"
                                        name="lgnPasswordCheck"
                                        register={memberRegister}
                                        errors={errors.lgnPasswordCheck}
                                        setValue={setValue}
                                        getValues={getValues}
                                        placeholder="비밀번호 확인"
                                        maxLength={20}
                                        id="lgnPasswordCheck"
                                        required={true}
                                        type={showPasswordCheck ? "text" : "password"}
                                        validation={{
                                            validate: (value) =>
                                                value === getValues('lgnPassword') || '비밀번호가 일치하지 않습니다'
                                        }}
                                        onInput={onInputOnlyEng}
                                    />
                                    <PasswordToggleButton
                                        showPassword={showPasswordCheck}
                                        isEvFormText={true}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setShowPasswordCheck(!showPasswordCheck);
                                        }}
                                    />
                                </div>
                                <EvFormText
                                    label="이름"
                                    name="nm"
                                    register={memberRegister}
                                    errors={errors.nm}
                                    setValue={setValue}
                                    getValues={getValues}
                                    placeholder="이름"
                                    maxLength={20}
                                    id="nm"
                                    required={true}
                                />
                                <EvFormPhone
                                    label="휴대폰 번호"
                                    phoneValue0={getValues('phoneFirst')}
                                    phoneValue1={getValues('phoneSecond')}
                                    phoneValue2={getValues('phoneThird')}
                                    id="phone"
                                    required={true}
                                />
                                <FormItem>
                                    <FormLabel htmlFor="email">
                                        이메일<span style={{ color: "#ff8116" }}>*</span>
                                    </FormLabel>
                                    <Flex flexDirection="column" alignItems="start" gap="4px">
                                        <Flex gap="6px">
                                            <Input
                                                style={{ height: "40px" }}
                                                type="text"
                                                {...memberRegister('emailId', {
                                                    required: '이메일을 입력해주세요',
                                                    pattern: {
                                                        value: /^[A-Za-z0-9._%+-]+$/,
                                                        message: '올바른 이메일 형식이 아닙니다'
                                                    }
                                                })}
                                                borderRadius="0.375rem"
                                                onInput={onInputOnlyEng}
                                            />
                                            @
                                            {watch('emailDomain') === 'other' && (
                                                <Input
                                                    style={{ height: "40px" }}
                                                    type="text"
                                                    {...memberRegister('emailDomainInput', {
                                                        required: watch('emailDomain') === 'other' ? '이메일 도메인을 입력해주세요' : false,
                                                        pattern: {
                                                            value: /^[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                                                            message: '올바른 도메인 형식이 아닙니다'
                                                        }
                                                    })}
                                                    borderRadius="0.375rem"
                                                    onInput={onInputOnlyEng}
                                                />
                                            )}
                                            <FormSelect
                                                {...memberRegister('emailDomain', {
                                                    required: '이메일 도메인을 선택해주세요',
                                                    onChange: (e) => {
                                                        if (e.target.value !== 'other') {
                                                            setValue('emailDomainInput', '');
                                                        }
                                                    }
                                                })}
                                            >
                                                <option value="">선택해주세요.</option>
                                                <option value="naver.com">naver.com</option>
                                                <option value="gmail.com">gmail.com</option>
                                                <option value="hanmail.net">hanmail.net</option>
                                                <option value="other">직접입력</option>
                                            </FormSelect>
                                        </Flex>
                                        {(errors.emailId || errors.emailDomain || errors.emailDomainInput) && <Div style={{ color: "red", fontSize: "14px" }}>이메일을 입력해주세요.</Div>}
                                    </Flex>
                                </FormItem>
                                <FormItem>
                                    <FormLabel htmlFor="id">
                                        결제카드 정보<span style={{ color: "#ff8116" }}>*</span>
                                    </FormLabel>
                                    <Flex flexDirection="column" alignItems="start" gap="4px">
                                        <Input
                                            style={{ height: "40px" }}
                                            type="text"
                                            placeholder="클릭하여 입력"
                                            maxLength={20}
                                            {...memberRegister("hiddenPaycardNo", {
                                                required: "결제카드 정보를 입력해주세요"
                                            })}
                                            onClick={() => { onClickChangePaycardHandler() }}
                                            borderRadius="0.375rem" />
                                        {errors.hiddenPaycardNo && <Div style={{ color: "red", fontSize: "14px" }}>결제카드 정보를 입력해주세요.</Div>}
                                    </Flex>
                                </FormItem>
                                <Input type="hidden" {...memberRegister("paycardNo")} name="paycardNo" />
                                <Input type="hidden" {...memberRegister("paycardExp")} name="paycardExp" />
                                <Input type="hidden" {...memberRegister("paycardBirth")} name="paycardBirth" />
                                <Input type="hidden" {...memberRegister("paycardPw")} name="paycardPw" />
                                <Form id="paycardForm" name="paycardForm" method="post">
                                    <input type="hidden" name="PayMethod" value="CARD" placeholder="" />
                                    <input type="hidden" name="Mid" maxLength={10} value={process.env.REACT_APP_SMARTRO_MID} placeholder="" />
                                    <input type="hidden" name="Moid" maxLength={40} value={Moid} placeholder="특수문자 포함 불가" />
                                    <input type="hidden" name="MallUserId" maxLength={20} value={TodayFormatYYYYMMDDHHmmssSSS()} placeholder="" />
                                    <input type="hidden" name="MallIp" maxLength={20} value="10.0.0.1" placeholder="" />
                                    <input type="hidden" name="UserIp" maxLength={20} value="10.0.0.1" placeholder="" />
                                    <input type="hidden" name="ReturnUrl" size={100} className="input" value={process.env.REACT_APP_API_URL + `/api/v1/users/register/result?company=false`} />
                                    <input type="hidden" name="VerifyValue" maxLength={100} className="input" value={EncryptData} placeholder="위/변조방지 HASH 데이터" />
                                    <input type="hidden" name="EncodingType" maxLength={14} value="utf-8" placeholder="utf-8 or euc-kr" />
                                    <input type="hidden" name="SspMallId" maxLength={20} value={process.env.REACT_APP_SMARTRO_SSPMALLID} placeholder="테스트용 SspMallId" />
                                    <input type="hidden" name="EdiDate" maxLength={14} value={EdiDate} placeholder="" />
                                    <input type="hidden" name="IsPwdPass" maxLength={1} value="Y" placeholder="" />
                                </Form>
                                <Div style={{ fontSize: "14px", color: fontGreyColor, marginTop: "6px" }}>
                                    *실물카드는 마이페이지 메뉴에서 신청할 수 있습니다.
                                </Div>
                                {
                                    watch('checkMemberCard') && (
                                        <Div style={{ marginTop: "20px" }}>
                                            <FormItem>
                                                <FormLabel htmlFor="rdnmadr">
                                                    배송지 주소<span style={{ color: "#ff8116" }}>*</span>
                                                </FormLabel>
                                                <Flex flexDirection="column" alignItems="start" gap="4px">
                                                    <Input
                                                        style={{ height: "40px" }}
                                                        type="text"
                                                        placeholder="클릭하여 입력"
                                                        onClick={postCodeHandleClick}
                                                        onKeyDown={(e) => e.preventDefault()}
                                                        {...memberRegister('rdnmadr', {
                                                            required: watch('checkMemberCard') ? '배송지 주소를 입력해주세요' : false,
                                                        })}
                                                        borderRadius="0.375rem"
                                                    />
                                                    {errors.rdnmadr && <Div style={{ color: "red", fontSize: "14px" }}>배송지 주소를 입력해주세요.</Div>}
                                                </Flex>
                                            </FormItem>
                                            <EvFormText
                                                label="배송지 상세주소"
                                                name="adresDetail"
                                                register={memberRegister}
                                                errors={errors.adresDetail}
                                                setValue={setValue}
                                                getValues={getValues}
                                                placeholder="클릭하여 입력"
                                                id="deliveryDetailAddress"
                                                required={watch('checkMemberCard')}
                                            />
                                        </Div>
                                    )
                                }
                                <Flex justifyContent="center" style={{ maxWidth: "336px", margin: "50px auto 0 auto" }}>
                                    <RoundButton type="submit" width="100%" fontSize="16px" height="46px" borderRadius="30px">통합회원가입</RoundButton>
                                </Flex>
                            </Form>
                        </>
                    }
                </LinkAccountSection>
            </PageLayout>
            <Loading isLoading={isLoading} /></>
    );
}

export default CreateAccountPage;
